var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 25,
    viewBox: "0 0 23 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_2)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1677 0.729849C11.3895 0.609409 11.657 0.608562 11.8795 0.727596L22.0582 6.17276C22.3021 6.30326 22.4544 6.55744 22.4544 6.83408V17.88C22.4544 18.1566 22.3021 18.4108 22.0582 18.5413L11.8795 23.9864C11.657 24.1055 11.3895 24.1046 11.1677 23.9842L1.14205 18.5391C0.900441 18.4078 0.75 18.1549 0.75 17.88V6.83408C0.75 6.55914 0.90044 6.30623 1.14205 6.17501L11.1677 0.729849ZM15.0428 4.12097L11.5284 2.24093L3.0461 6.84784L6.51803 8.81433L15.0428 4.12097ZM8.05105 9.68263L16.6202 4.96482L20.1402 6.84788L11.5285 11.6522L8.05105 9.68263ZM10.7757 12.9497L2.25 8.12083V17.4339L10.7757 22.0643V12.9497ZM12.2757 22.0733L20.9544 17.4306V8.11131L12.2757 12.953V22.0733Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 24,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderIcon);
export default __webpack_public_path__ + "static/media/order-icon.8612486cf1cdf135ba6f673c64fe8751.svg";
export { ForwardRef as ReactComponent };